import { COMMAND_STATUS } from "../master/sync/commandTypes";

/**
 * Turn command-queue failures (plain objects) into user-facing text.
 */
export function normalizeMutationFailure(error) {
   if (!error) return "Operația calendar nu a putut fi finalizată.";
   if (typeof error === "string") return error;
   if (error instanceof Error) {
      return String(error.message || "Operația calendar nu a putut fi finalizată.");
   }

   const status = String(error?.status || "").trim().toLowerCase();
   const nested = error?.error;

   if (nested instanceof Error) {
      return String(nested.message || "Operația calendar nu a putut fi finalizată.");
   }
   if (nested && typeof nested === "object") {
      const nestedMessage = String(
         nested.message || nested.code || nested.error || "",
      ).trim();
      if (nestedMessage) return nestedMessage;
   }

   if (status === COMMAND_STATUS.TIMEOUT) {
      return "Operația a expirat. Calendarul este încă ocupat — încearcă din nou.";
   }
   if (status === COMMAND_STATUS.FAILED) {
      return "Operația calendar nu a putut fi finalizată.";
   }
   if (status) return status;
   return "Operația calendar nu a putut fi finalizată.";
}
